import React from "react";
import InterruptButton from "@components/FlowActionButtons/InterruptButton";

interface CancelPortServiceProps {
  portServiceData?: {
    id: string;
    status: string;
  };
  openCancelDrawer: (row: any) => void;
}
const LANG_BASE = "vessel-call.port-services";

const CancelPortService: React.FC<CancelPortServiceProps> = ({
  portServiceData,
  openCancelDrawer,
}) => {
  if (!portServiceData) {
    return null;
  }

  const handleCancelClick = () => {
    openCancelDrawer(portServiceData);
  };

  const isActionAvailable =
    portServiceData.status !== "CANCELLED" &&
    portServiceData.status !== "COMPLETED" &&
    portServiceData.status !== "REJECTED" &&
    portServiceData.status !== "CLOSED";

  return (
    <InterruptButton
      langBase={LANG_BASE}
      permission="canCancelPortService"
      isActionAvailable={isActionAvailable}
      onInterrupt={handleCancelClick}
    />
  );
};
export default CancelPortService;
